import {
  Controller,
  Control,
  FieldValues,
  Path,
  RegisterOptions,
} from 'react-hook-form';
import CurrencyInput, { CurrencyInputProps } from 'react-currency-input-field';
import TextField, { TextFieldProps } from '@mui/material/TextField';

interface CurrencyInputFieldProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label?: string;
  defaultValue?: string | number;
  rules?: RegisterOptions<T>;
  prefix?: string;
  suffix?: string;
  decimalsLimit?: number;
  decimalScale?: number;
  currencyInputProps?: Omit<
    CurrencyInputProps,
    'name' | 'value' | 'onValueChange' | 'onBlur' | 'customInput' | 'inputRef'
  >;
  textFieldProps?: Omit<
    TextFieldProps,
    'name' | 'value' | 'onChange' | 'onBlur' | 'inputRef'
  >;
}

const CurrencyInputField = <T extends FieldValues>({
  name,
  control,
  defaultValue = '',
  rules = {},
  prefix = '$',
  suffix,
  decimalsLimit = 2,
  decimalScale = 2,
  currencyInputProps = {},
  textFieldProps = {},
}: CurrencyInputFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue as any}
      rules={rules}
      render={({ field: { onChange, onBlur, value } }) => (
        <CurrencyInput
          id={name}
          name={name}
          value={value}
          onValueChange={(value) => {
            onChange(value);
          }}
          onBlur={onBlur}
          prefix={prefix}
          suffix={suffix}
          decimalsLimit={decimalsLimit}
          decimalScale={decimalScale}
          customInput={TextField}
          {...currencyInputProps}
          {...(textFieldProps as any)}
        />
      )}
    />
  );
};

export default CurrencyInputField;
